import actionTypes from '../actionTypes';

const initialState = {
  os: null,
  type: null,
  launcherDetails: null,
  systemBrowserOsInfo: null
};

const DeviceDetailsReducer = (state = initialState, action) => {
  if (action.type === actionTypes.DEVICE_DETAILS) {
    return action.payload;
  }
  return state;
};

export default DeviceDetailsReducer;
